import {getPrivateAxios} from '../../libs';
import {Guide} from './types';

export const fetchGuideComplete = async (guideId: string) => {
  return getPrivateAxios()
    .patch<{guide: Guide; discountId: string | null}>(`/guides/${guideId}/complete`)
    .then((response) => response.data);
};
